// Runtime endpoints. Injected by vite.config.ts from the repo-root .env (API_URL, GATEWAY_URL, SITE_URL);
// the desktop shell overrides them through window.moodsDesktop.config (Phase 12 bridge, packages/shared desktop.ts),
// the iOS app through window.moodsNative.config (packages/shared native.ts).
import type { CapacitorBridgeGlobal, MoodsDesktopBridge, MoodsNativeShell } from '@moods/shared';

declare global {
  interface Window {
    moodsDesktop?: MoodsDesktopBridge;
    moodsNative?: MoodsNativeShell;
    Capacitor?: CapacitorBridgeGlobal;
  }
}

const desktop = typeof window !== 'undefined' ? window.moodsDesktop?.config : undefined;
const ios = typeof window !== 'undefined' && window.moodsNative?.platform === 'ios' ? window.moodsNative.config : undefined;

export const API_URL: string = (desktop?.apiUrl ?? ios?.apiUrl ?? import.meta.env.VITE_API_URL ?? 'http://localhost:4000').replace(/\/$/, '');
export const GATEWAY_URL: string = desktop?.gatewayUrl ?? ios?.gatewayUrl ?? import.meta.env.VITE_GATEWAY_URL ?? 'ws://localhost:4000/gateway';
export const SITE_URL: string = (desktop?.siteUrl ?? ios?.siteUrl ?? import.meta.env.VITE_SITE_URL ?? 'http://localhost:4321').replace(/\/$/, '');
export const IS_DESKTOP = typeof window !== 'undefined' && Boolean(window.moodsDesktop);
/** The MOODS iOS app (apps/ios): WKWebView — no screen share, no web push, no global shortcuts (lib/ios.ts). */
export const IS_IOS_APP = Boolean(ios);
/**
 * The web build bundled inside a MOODS app (desktop or iOS) on `app://moods`: cookies never reach the API from there
 * (tokens travel in the body and the shell keeps them), no service worker, and a new build arrives with the app.
 */
export const IS_APP_SHELL = IS_DESKTOP || IS_IOS_APP;
export const PLATFORM: 'web' | 'desktop-win' | 'desktop-mac' | 'mobile-web' | 'ios' = IS_DESKTOP
  ? window.moodsDesktop?.platform === 'darwin'
    ? 'desktop-mac'
    : 'desktop-win'
  : IS_IOS_APP
    ? 'ios'
    : typeof navigator !== 'undefined' && /Mobi|Android|iPhone/.test(navigator.userAgent)
      ? 'mobile-web'
      : 'web';
